/** Strip trailing slash; empty when unset (same-origin / Vite proxy). */
export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (!raw || typeof raw !== 'string' || raw.trim() === '') {
    return '';
  }

  const trimmed = raw.trim().replace(/\/$/, '');
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
}

/** Prefix relative API paths with VITE_API_BASE_URL when configured. */
export function resolveApiUrl(input: RequestInfo | URL): RequestInfo | URL {
  const base = getApiBaseUrl();
  if (!base) {
    return input;
  }

  if (typeof input === 'string' && input.startsWith('/')) {
    return `${base}${input}`;
  }

  return input;
}
